<template>
    <div>
        <v-btn
            v-if="(id && can('api.v1.pharmacy-sites.update')) || (!id && can('api.v1.pharmacy-sites.store'))"
            color="primary"
            rounded
            class="mr-5"
            :loading="pharmacySitesFormLoading"
            :disabled="disabled || readOnlyRules"
            large
            @click="saveConsultant()"
        >
            {{ isAdmin ? t('pharmacy-sites::button.submit') : t('pharmacy-sites::button.send_save_request') }}</v-btn
        >
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            pharmacySitesFormLoading: false,
        };
    },
    computed: {
        id() {
            return this.$store.state.pharmacy_sites.pharmacy_site.id;
        },
        readOnlyRules() {
            const urlParams = new URLSearchParams(window.location.search);
            const preview = urlParams.get('preview');
            const isPreviewMode = preview && preview === 'true';
            if (isPreviewMode) {
                return true;
            }
            return !this.can('api.v1.pharmacy-sites.update') && this.can('api.v1.pharmacy-sites.show');
        },
        isAdmin() {
            return User.group === 'admins';
        },
    },
    methods: {
        async saveConsultant() {
            this.pharmacySitesFormLoading = true;
            this.$store.dispatch('pharmacy_sites/resetErrorMessages');
            axios({
                method: this.id ? 'put' : 'post',
                url: this.id
                    ? route('api.v1.pharmacy-sites.update', { pharmacy_site: this.id })
                    : route('api.v1.pharmacy-sites.store'),
                data: this.$store.state.pharmacy_sites.pharmacy_site,
            })
                .then(() => {
                    _.delay(() => {
                        this.$root.goTo(route('pharmacy-sites.index'));
                    }, 1000);
                    if (!this.id) {
                        if (this.isAdmin) {
                            return this.$root.notify(
                                'info',
                                t('pharmacy-sites::notification.success'),
                                t('pharmacy-sites::notification.pharmacy_sites.created')
                            );
                        } else {
                            return this.$root.notify(
                                'info',
                                t('pharmacy-sites::notification.success'),
                                t('pharmacy-sites::notification.pharmacy_sites.send_approval')
                            );
                        }
                    }
                    if (this.id) {
                        if (this.isAdmin) {
                            return this.$root.notify(
                                'info',
                                t('pharmacy-sites::notification.success'),
                                t('pharmacy-sites::notification.pharmacy_sites.update')
                            );
                        } else {
                            return this.$root.notify(
                                'info',
                                t('pharmacy-sites::notification.success'),
                                t('pharmacy-sites::notification.pharmacy_sites.send_approval')
                            );
                        }
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('pharmacy_sites/setErrorMessages', error.response.data.errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => _.delay(() => (this.pharmacySitesFormLoading = false), 1400));
        },
    },
};
</script>

<style></style>
